export default (list, value) => {
  let min;
  let chosen = 0;

  for (let i in list) {
    min = Math.abs(list[chosen].value - value);

    if (Math.abs(list[i].value - value) < min) {
      chosen = i;
    }
  }

  return chosen;
};
